export default "__VITE_ASSET__DIBdGZV6__"